export default {"src":"/_next/static/media/relaxing-together.colour.c1cec467.svg","height":171,"width":280,"blurWidth":0,"blurHeight":0};